import React, { useEffect, useMemo, useState } from "react";
import Dialog from "../../../components/Dialog";
import Button from "../../../components/Button";
import { CustomIcon } from "../../../components/Icons";
import EventBus, { EventNames } from "../../utils/event-bus";
import { useNavigate } from "react-router-dom";
import { useBattleContext } from "../../context";
import { BattleResult } from "../../types";
import { useSelector } from "react-redux";
import useTriggerEvent from '../../hooks/useTriggerEvent';
import { useAppTranslation } from "../../../i18n/useAppTranslation";

const BattleResultDialog = () => {
  const { t } = useAppTranslation("battle");
  const [open, setOpen] = React.useState(false);
  const { messages } = useBattleContext();
  const triggerEvent = useTriggerEvent();
  const [battleResult, setBattleResult] = useState<BattleResult>();
  const userInfo = useSelector((state: any) => state.userInfo);
  const navigate = useNavigate();
  const [isWinner, setIsWinner] = useState<any>(undefined);
  const [battleId, setBattleId] = useState(0);
  useEffect(() => {
    EventBus.on(EventNames.EndBattle, ({ battleId }) => {
      setBattleId(+battleId);
      setOpen(true);
    });
    return () => {
      EventBus.off(EventNames.EndBattle, ({ battleId }) => {
        setBattleId(+battleId);
        setOpen(true);
      });
    };
  }, []);

  useEffect(() => {
    EventBus.on(EventNames.BattleResult, (d) => {
      setBattleResult(d);
    });
    return () => {
      EventBus.off(EventNames.BattleResult, (d) => {
        setBattleResult(d);
      });
    };
  }, []);

  const filteredResults = useMemo(() => {
    if (!battleResult) return undefined;
    const isWinner = battleResult.winners.players.find(
      (p) => p.playerId === userInfo.id
    );
    const isLoser = battleResult.losers.players.find(
      (p) => p.playerId === userInfo.id
    );
    if (isWinner) setIsWinner(true);
    if (isWinner) return battleResult.winners;
    if (isLoser) return battleResult.losers;
  }, [battleResult]);

  return (
    <Dialog
      onSubmit={() => {
       setTimeout(() => {
        triggerEvent(EventNames.ResetArenaTour, { tourId: "arenaTour" });
       }, 2000);
        navigate("/home");
        setOpen(false);
      }}
      submitLabel={
        <>
          <CustomIcon icon="home" width={18} height={18} className="me-1" />
          {t("battleResult.home")}
        </>
      }
      closeLabel={<>{t("battleResult.replay")}</>}
      open={open}
      noHeader
      onClose={() => {
        setOpen(false);
        window.location.href = "/arena/live?replayId=" + battleId;
      }}
    >
      {filteredResults && (
        <img
          style={{ marginTop: -200 }}
          className="mx-auto d-block mb-2"
          width={"80%"}
          src={
            isWinner
              ? "/assets/images/battle/victory.png"
              : "/assets/images/battle/defeat.png"
          }
        />
      )}
      {filteredResults ? (
        <div className="text-center w-100">
          <span className="fs-md dark-yellow">
            {isWinner
              ? t("battleResult.victory")
              : t("battleResult.defeat")}
          </span>
        </div>
      ) : (
        messages &&
        messages[messages.length - 1]?.message && (
          <div className="text-center w-100">
            <span className="fs-md dark-yellow">
              {messages[messages.length - 1]?.message}
            </span>
          </div>
        )
      )}
      {filteredResults && (
        <>
          <div className="d-flex gap-3 mt-3 align-items-end justify-content-center">
            <div
              style={{ maxWidth: 80, height: "fit-content" }}
              className="item-frame mx-0 active-slot  my-0 py-2 flex-column "
            >
              <img
                width={30}
                className="circle mt-1"
                src="/assets/images/arena/icons/energy-icon.png"
              />
              <span className="fs-md dark-yellow text-center mb-2">
                -{filteredResults?.energyCost}
              </span>
            </div>

            <div
              style={{ maxWidth: 80, height: "fit-content" }}
              className="item-frame mx-0 active-slot  my-0 py-2 flex-column "
            >
              <img
                width={30}
                className="circle mt-1"
                src={
                  filteredResults?.clegReward !== -1
                    ? "/assets/images/icons/cleg.png"
                    : "/assets/images/arena/icons/gem-icon.png"
                }

              />
              <span className="fs-md  dark-yellow text-center mb-2">
                {filteredResults?.clegReward > 0 ||
                filteredResults?.bloodGemReward > 0
                  ? "+"
                  : ""}
                {filteredResults?.clegReward !== -1
                  ? filteredResults?.clegReward
                  : filteredResults?.bloodGemReward}
              </span>
            </div>
            <div
              style={{ maxWidth: 80, height: "fit-content" }}
              className="item-frame active-slot mx-0 my-0 py-2 flex-column "
            >
              <img
                width={30}
                height={31}
                className="circle mt-1"
                src="/assets/images/icons/xp.svg"
              />
              <span className="fs-md dark-yellow text-center mb-2">
                +{filteredResults?.xp}
              </span>
            </div>
          </div>
          <div
            style={{ marginBottom: -30 }}
            className="d-flex gap-3 mt-3 align-items-center justify-content-center flex-column"
          >
            <Button
              variant="rounded"
              style={{ color: "rgba(0, 0, 0, 0.5)", fontWeight: "bold" }}
              className="mt-3 p-1 px-4 bg-100 fs-small  no-hover"
            >
              SCORE
            </Button>
            <div className="dark-yellow fs-big ">
              +{filteredResults?.score}{" "}
              <CustomIcon icon="cup" width={24} className="mb-1" height={24} />
            </div>
          </div>{" "}
        </>
      )}
    </Dialog>
  );
};

export default BattleResultDialog;
